import moment, { Moment } from 'moment/moment'

export interface LifetimeUserPayload {
    id: number
    user_id: number
    email: string | null
    product_id: string
    starts_at: string | null
    active: boolean
}

export class LifetimeUser {
    id: number
    userId: number
    email: string | null
    productId: string
    startsAt: Moment | null
    active: boolean

    constructor(data: LifetimeUserPayload) {
        this.id = data.id
        this.userId = data.user_id
        this.email = data.email
        this.productId = data.product_id
        this.startsAt = data.starts_at ? moment(data.starts_at) : null
        this.active = data.active
    }
}
